<div class="options-management-container">

  <h3><span class="back-link" (click)="returnOnOfferSelection()" translate>T_OFFER_DATA_MANAGEMENT_BACK_BUTTON</span></h3>

  <div>
    <div class="titles">
      <p class="range-key" translate><span translate>T_OFFER_DATA_MANAGEMENT_OPTIONS_LIST_OF_RANGE </span>{{selectedRange.nameKey}}</p>
    </div>
  </div>

  <div *ngIf="!isLoading">

    <div class="button-container">
      <input [(ngModel)]="searchValue" (ngModelChange)="searchInputChanged()" [placeholder]="searchPlaceholder"/>
      <button class="btn btn-smart btn-gray" (click)="onClickAddOptionButton()" translate>
        <span class="se-icons">action_add_stroke</span>T_OPTION_ADD_BUTTON
      </button>
      <button class="btn btn-smart btn-gray" (click)="onClickAddOptionValueButton()" translate>
        <span class="se-icons">action_add_stroke</span>T_OPTION_VALUE_ADD_BUTTON
      </button>
      <button class="btn btn-smart btn-gray" (click)="onClickExportOptionsButton()" translate>
        <span class="se-icons">action_download</span>T_PRICE_EXPORT
      </button>
      <app-spinner *ngIf="isExportLoading" [vCenter]="false" [sizeClass]="'extra-small'"></app-spinner>
    </div>

    <h6 *ngIf="searchValue && displayedOptions.length === 0" translate>T_SEARCH_NO_MATCH</h6>

    <div class="options-list">
      <app-odm-options-list
        [selectedRange]="selectedRange"
        [activeOption]="activeOption"
        [options]="displayedOptions"
        [showOnPopUpStatus]="showOnPopUpManagement()"
        (clickEditOptionButton)="onClickEditOptionButton($event)"
        (clickDeleteOptionButton)="onClickDeleteOptionButton($event)"
        (clickCopyOptionButton)="onClickCopyOptionButton($event)"
        (clickEditOptionValueButton)="onClickEditOptionValueButton($event)"
        (clickDeleteOptionValueButton)="onClickDeleteOptionValueButton($event)"
        (changeOptionValueOrderEvent)="onChangeOptionsValueOrder($event)"
      >
      </app-odm-options-list>
    </div>
  </div>

  <div *ngIf="isLoading" class="odm-left-column">
    <app-spinner [sizeClass]="'large'"></app-spinner>
  </div>
</div>

<app-odm-edit-option-modal #addOptionModal
                           (saveOption)="addOption($event)">
</app-odm-edit-option-modal>

<app-odm-edit-option-modal #editOptionModal
                           (saveOption)="editOption($event)">
</app-odm-edit-option-modal>

<app-odm-copy-option-modal #copyOptionModal
                           (saveOption)="copyOption($event)"
                           [rangeId]="selectedRange.id">
</app-odm-copy-option-modal>
<app-common-modal #deleteOptionModal [name]="'deleteOptionModal'" (onClickYesButton)="deleteOption()"
                  [description]="'T_DELETE_OPTION_MODAL_MESSAGE' | translate">
  <div modal-body  *ngIf="associatedOptionUsages.length">
    <strong class="modal-reference-heading">{{ 'T_OPTION_ASSOCIATED_REFERENCES_MESSAGE' | translate }}</strong>
    <ng-container
      [ngTemplateOutlet]="usageListTemplate"
      [ngTemplateOutletContext]="{ $implicit: associatedOptionUsages }">
    </ng-container>
  </div>
</app-common-modal>
<app-odm-edit-option-value-modal #addOptionValueModal
                                 (saveOptionValue)="addOptionValue($event)"
                                 [selectedRange]="selectedRange"
                                 [options]="displayedOptions">
</app-odm-edit-option-value-modal>

<app-odm-edit-option-value-modal #editOptionValueModal
                                 (saveOptionValue)="editOptionValue($event)"
                                 [selectedRange]="selectedRange"
                                 [options]="displayedOptions">
</app-odm-edit-option-value-modal>
<app-common-modal #deleteOptionValueModal [name]="'deleteOptionValueModal'" (onClickYesButton)="deleteOptionValue()"
                  [description]="'T_DELETE_OPTION_VALUE_MODAL_MESSAGE' | translate">
  <div modal-body  *ngIf="associatedOptionValueUsages.length">
    <strong class="modal-reference-heading">{{ 'T_OPTION_VALUE_ASSOCIATED_REFERENCES_MESSAGE' | translate }}</strong>
    <ng-container
      [ngTemplateOutlet]="usageListTemplate"
      [ngTemplateOutletContext]="{ $implicit: associatedOptionValueUsages }">
    </ng-container>
  </div>
</app-common-modal>

<ng-template #usageListTemplate let-usages>
  <ul class="modal-reference-list">
    <li *ngFor="let usage of usages">
      <span class="usage-category">{{ usage.category }}</span>
      <span class="usage-separator">-</span>
      <span class="usage-component">{{ usage.component }}</span>
    </li>
  </ul>
</ng-template>
